<template>
    <photos :config="config" :key="config.storeField"></photos>
</template>
<script>
    import Photos from '../template/Photos';

    export default {
        components: {Photos},
        data: function () {
            return {
                config: {
                    question: 'Upload a photo of your government issued ID or drivers license',
                    storeField: 'identification_photos',
                    showBackOption: false,
                    clickBack: function () {
                        this.$router.go(-1)
                    }.bind(this),
                    clickContinue: async function () {
                        await this.$router.push('/reg/summary')
                    }.bind(this)
                }
            }
        }
    }
</script>
